import React, { useContext, useState } from "react";
import { CompanyInfo, CompanyType } from "services/apis/types/company/CompanyInfo";
import ActionDropdownItem from "components/networkExplorer/common/ActionDropdownItem";
import OrganizationModal from "./OrganizationModal";
import OrganizationDeleteModal from "./OrganizationDeleteModal";
import { ManageAction } from "components/manage/types/ManageAction";
import { useHistory } from "react-router-dom";
import { AppContext } from "services/appContext/AppContext";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

type Props = {
  company: CompanyInfo;
  availableCompanies: CompanyInfo[];
};

export default function OrganizationActionsCell(props: Props) {
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);
  const [showFeesModal, setShowFeesModal] = useState(false);
  const {appContext, setAppContext} = useContext(AppContext);

  const history = useHistory();
  const companyId = props.company.id;


  const feesAction = () => {
  const profileCompanyId = 
    props.company.companyType === CompanyType.Child
      ? props.company.parentId  
      : companyId;             
        const spIdProfile = appContext.localStorageInfo.user
    ? appContext.localStorageInfo.user.spIdProfiles.find(
        (x) => x.companyId === profileCompanyId
      )
    : undefined;

  if (spIdProfile) {
    setAppContext({
      ...appContext,
      localStorageInfo: { ...appContext.localStorageInfo, selectedProfile: spIdProfile }
    });
    history.push({ pathname: '/billing' });
  }
};

  return (
    <>
      <Dropdown
        nav
        isOpen={actionsOpen}
        toggle={() => setActionsOpen(prevState => !prevState)}
        className="col-4 text-right">
        <DropdownToggle className="nav-link pr-0 cursor-pointer" color="" tag="a">
          <i className="far fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu right positionFixed>
          <ActionDropdownItem
            handleAction={() => setShowModifyModal(true)}
            iconClassName="fa fa-edit"
            labelId="manage.organization.table.actions.modify"
          />
          <ActionDropdownItem
            handleAction={() => feesAction()}
            iconClassName="fa fa-usd-circle"
            labelId="manage.organization.table.actions.fees"
          />
          <ActionDropdownItem
            handleAction={() => setShowDeleteModal(true)}
            iconClassName="fa fa-trash-alt"
            labelId="manage.organization.table.actions.delete"
          />
        </DropdownMenu>
      </Dropdown>
      {showModifyModal && (
        <OrganizationModal
          manageAction={ManageAction.Modify}
          companyId={props.company.id}
          availableCompanies={props.availableCompanies.filter(x => x.id !== props.company.id)}
          closeModal={() => setShowModifyModal(false)}
        />
      )}
      {showDeleteModal && (
        <OrganizationDeleteModal
          id={props.company.id}
          name={props.company.name}
          closeModal={() => setShowDeleteModal(false)}
        />
      )}
    </>
  );
}
